<div class="w-full flex flex-col items-center py-4">
    <div class="flex flex-col gap-5 w-full max-w-[632px] px-4">
        <!-- Back to overview button -->
        <button mat-button class="text-app-global-primary mr-auto" routerLink="/settings/users" i18n>
            <mat-icon svgIcon="arrow-left"></mat-icon>
            Terug naar overzicht
        </button>

        <!-- Page title -->
        <div class="flex items-center gap-4">
            <!-- Title -->
            <h1 *ngIf="userId" class="text-[22px] font-semibold shrink-0" i18n>Gebruiker bewerken</h1>
            <h1 *ngIf="!userId" class="text-[22px] font-semibold shrink-0" i18n>Gebruiker aanmaken</h1>

            <!-- Current user name -->
            <p *ngIf="user && breakpoint.sm.value"
                class="text-[22px] px-[8px] py-[10px] bg-app-global-quaternary text-app-global-quaternary-contrast rounded-[5px] whitespace-nowrap text-ellipsis overflow-hidden">
                {{user.name}}
            </p>
        </div>

        <!-- First name -->
        <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
            <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>Voornaam</p>
            <mat-form-field class="grow w-full sm:max-w-[420px]">
                <input matInput i18n-placeholder placeholder="Voornaam"
                    [formControl]="userFormGroup.controls.firstName">
                <mat-error *ngIf="userFormGroup.controls.firstName.hasError('required')" i18n>
                    Veld is verplicht
                </mat-error>
                <mat-error *ngIf="userFormGroup.controls.firstName.hasError('maxlength')" i18n>
                    Maximaal 100 karakters
                </mat-error>
            </mat-form-field>
        </div>

        <!-- Last name -->
        <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
            <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>Achternaam</p>
            <mat-form-field class="grow w-full sm:max-w-[420px]">
                <input matInput i18n-placeholder placeholder="Achternaam"
                    [formControl]="userFormGroup.controls.lastName">
                <mat-error *ngIf="userFormGroup.controls.lastName.hasError('required')" i18n>
                    Veld is verplicht
                </mat-error>
                <mat-error *ngIf="userFormGroup.controls.lastName.hasError('maxlength')" i18n>
                    Maximaal 100 karakters
                </mat-error>
            </mat-form-field>
        </div>

        <!-- Email -->
        <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
            <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n
                [ngClass]="{'text-app-global-text-secondary': userFormGroup.controls.email.disabled}">E-mail</p>
            <mat-form-field class="grow w-full sm:max-w-[420px]">
                <input matInput i18n-placeholder placeholder="E-mail" [formControl]="userFormGroup.controls.email">
                <mat-error *ngIf="userFormGroup.controls.email.hasError('required')" i18n>Veld is verplicht</mat-error>
                <mat-error *ngIf="userFormGroup.controls.email.hasError('email')" i18n>Ongeldig e-mailadres</mat-error>
                <mat-error *ngIf="userFormGroup.controls.email.hasError('emailTaken')" i18n>
                    E-mailadres al in gebruik
                </mat-error>
                <mat-error *ngIf="userFormGroup.controls.email.hasError('maxlength')" i18n>
                    Maximaal 100 karakters
                </mat-error>
            </mat-form-field>
        </div>

        <!-- Rol -->
        <div class="w-full flex flex-col items-start justify-between gap-2">
            <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>Rol</p>
            <mat-radio-group class="flex flex-col gap-2" [formControl]="userFormGroup.controls.role">
                <!-- Only show admin option if logged in user is admin, or if the openened user is admin -->
                <mat-radio-button value="admin" *ngIf="connection.role.value === 'admin' || user?.role === 'admin'">
                    <p i18n>Admin</p>
                    <p class="text-sm text-app-global-text-secondary" i18n>
                        Kan organisaties, gebuikers en collecties beheren
                    </p>
                </mat-radio-button>
                <mat-radio-button value="manager">
                    <p i18n>Manager</p>
                    <p class="text-sm text-app-global-text-secondary" i18n>
                        Kan gebuikers en collecties beheren
                    </p>
                </mat-radio-button>
                <mat-radio-button value="editor">
                    <p i18n>Bewerker</p>
                    <p class="text-sm text-app-global-text-secondary" i18n>
                        Kan collecties beheren
                    </p>
                </mat-radio-button>
                <mat-radio-button value="chatter">
                    <p i18n>Chatter</p>
                    <p class="text-sm text-app-global-text-secondary" i18n>
                        Kan alleen chatten en collecties bekijken
                    </p>
                </mat-radio-button>
            </mat-radio-group>
        </div>

        <!-- Password -->
        <div class="w-full flex flex-col sm:flex-row items-start sm:items-start justify-between gap-2 sm:gap-5">
            <p class="leading-normal text-base font-semibold shrink-0 min-w-[120px] sm:leading-[50px]" i18n>
                Tijdelijk wachtwoord
            </p>
            <div class="flex flex-col w-full">
                <div
                    class="flex items-center grow w-full sm:max-w-[420px] border border-app-form-field-border rounded-[4px] h-[48px] p-[13px]">
                    <!-- New password and copy button -->
                    <ng-container *ngIf="!userId || updatePassword">
                        <p class="text-app-global-text-primary text-base">{{temporaryPassword}}</p>
                        <button mat-icon-button i18n-matTooltip matTooltip="Naar klembord kopiëren"
                            [cdkCopyToClipboard]="temporaryPassword" class="scale-[85%]">
                            <mat-icon svgIcon="clipboard" class="text-app-global-text-primary"></mat-icon>
                        </button>
                    </ng-container>
                    <!-- Create new password button -->
                    <button mat-button class="text-app-global-secondary" *ngIf="!updatePassword && userId" i18n
                        (click)="updatePassword = true">
                        Klik om een nieuw wachtwoord te maken
                    </button>
                </div>
                <p class="text-app-global-text-secondary text-sm mt-[2px]" *ngIf="!userId || updatePassword" i18n>
                    Deel dit wachtwoord met de gebruiker
                </p>
            </div>
        </div>


        <!-- Delete / Cancel / Save -->
        <div class="flex justify-between gap-5 items-center">
            <button mat-button class="text-app-global-warning" (click)="deleteUser(deleteDialog)"
                [ngClass]="{'invisible': !userId}" i18n>
                Gebruiker verwijderen
            </button>
            <div class="flex items-center gap-5">
                <button mat-button class="text-app-global-text-secondary" routerLink="/settings/users" i18n>
                    Annuleren
                </button>
                <button mat-flat-button color="primary" (click)="user ? updateUser() : saveUser()" i18n>
                    Opslaan
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Dialog to show when user wants to delete the user -->
<dynamic-dialog #deleteDialog>
    <h1 title i18n>Gebruiker verwijderen</h1>
    <p class="text-center" i18n>
        Weet je zeker dat je deze gebruiker wilt verwijderen?
    </p>
</dynamic-dialog>